import React, { useState } from 'react';
import {
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Alert
} from 'reactstrap';
import { connect } from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import { createQuarterlyTransactions } from '../../api/transaction';

const AddQuarterlyTransactionModal = ({
  authUser,
  isOpen,
  data,
  childInfo,
  closeModal,
  setSuccessAlert
}) => {
  const [errorAlert, setErrorAlert] = useState({ show: false, message: '' });
  const [selectedAddress, setSelectedAddress] = useState(null);
  const addressOptions = [
    {
      value:
        'White House, Mahatma Gandhi Rd, near Lakshminarayan Temple, Kandivali, Bhagat Colony, Kandivali West, Mumbai, Maharashtra 400067',
      label:
        'White House, Mahatma Gandhi Rd, near Lakshminarayan Temple, Kandivali, Bhagat Colony, Kandivali West, Mumbai, Maharashtra 400067'
    },
    {
      value: 'Shop 02, Off Link Road, Extension, Mahavir Nagar, Kandivali West, Mumbai, Maharashtra 400067',
      label:
        'Shop 02, Off Link Road, Extension, Mahavir Nagar, Kandivali West, Mumbai, Maharashtra 400067'
    },
    {
      value: 'PLOT NO 154, RSC 15, Shri Ganeshkrupa Society, Samabhav Society, Gorai 2, Borivali West, Mumbai, Maharashtra 400091',
      label:
        'PLOT NO 154, RSC 15, Shri Ganeshkrupa Society, Samabhav Society, Gorai 2, Borivali West, Mumbai, Maharashtra 400091'
    }
  ];
  const [loading, setLoading] = useState(false);

  const handleCreate = async () => {
    if (!selectedAddress) {
      setErrorAlert({ show: true, message: 'Please select an address' });
      return;
    }
    const finalData = { ...data, address: selectedAddress.value };
    setLoading(true);
    const { response, error } = await createQuarterlyTransactions(finalData);
    setLoading(false);
    if (error) {
      setErrorAlert({ show: true, message: error });
      return;
    }
    setSuccessAlert({
      show_alert: true,
      message: 'Transactions created successfully'
    });
    handleClose();
  };

  const handleClose = () => {
    setSelectedAddress(null);
    closeModal();
  };
  return (
    <Modal isOpen={isOpen} backdrop="static" size="md">
      <ModalHeader>Create Transactions for {childInfo.name}</ModalHeader>
      <ModalBody>
        {errorAlert.show && (
          <Alert
            color="danger"
            role="alert"
            isOpen={errorAlert.show}
            toggle={() => setErrorAlert({ show: false, message: '' })}
          >
            <i className="mdi mdi-block-helper mr-2"></i>
            {errorAlert.message}
          </Alert>
        )}
        <Row>
          <Col md="12">
            <FormGroup>
              <Label>Select Address</Label>
              <Select
                options={addressOptions}
                onChange={(e) => setSelectedAddress(e)}
                value={selectedAddress}
              />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button
          size="sm"
          type="button"
          color="primary"
          onClick={handleCreate}
          disabled={loading}
        >
          {loading ? 'Creating...' : 'Create'}
        </Button>
        <Button size="sm" type="button" color="light" onClick={handleClose}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    authUser: state.Login?.user
  };
};

export default connect(mapStateToProps)(AddQuarterlyTransactionModal);
